export default function authHeader() {
    // return authorization header with jwt token
    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.userToken) {
        return { 'Authorization': 'Bearer ' + user.userToken };
    } else {
        return {};
    }
}